import type { EditorNumberFormValues } from "./schema-builder-field-editor-number.type";
import type { GetEditorValuesOptions } from "../schema-builder-field-editor.type";
import type { SchemaFieldNumber } from "@/entities/schema";

import { isSchemaFieldNumber } from "@/entities/schema";
import { isEqualNumber, isValidNumber } from "@/utilities/number";

import {
  getEditorDefaultValues,
  getNewSchemaFieldOptionsFromValues,
  isEditorDefaultFormValuesEqual,
} from "../schema-builder-field-editor-default";

export const getEditorNumberValues = (
  options: GetEditorValuesOptions
): EditorNumberFormValues => {
  const { schema } = options;

  const values: EditorNumberFormValues = {
    fieldType: "number",
    ...getEditorDefaultValues(options),
  };

  if (!isSchemaFieldNumber(schema)) return values;

  if (isValidNumber(schema.min)) values.min = schema.min;
  if (isValidNumber(schema.max)) values.max = schema.max;

  return values;
};

export const isEditorNumberFormValuesEqual = (
  a: EditorNumberFormValues,
  b: EditorNumberFormValues
) => {
  if (!isEditorDefaultFormValuesEqual(a, b)) return false;
  if (!isEqualNumber(a.min, b.min)) return false;
  if (!isEqualNumber(a.max, b.max)) return false;
  return true;
};

export const getNewSchemaNumberFromValues = (
  values: EditorNumberFormValues
): SchemaFieldNumber => {
  const schema: SchemaFieldNumber = {
    type: "input",
    inputType: "number",
    ...getNewSchemaFieldOptionsFromValues(values),
  };

  if (isValidNumber(values.min)) schema.min = values.min;
  if (isValidNumber(values.max)) schema.max = values.max;

  return schema;
};
